import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

const MemberShortForm = ({ memberId, toggle }) => {
    const [details, setDetails] = useState(null);
    const [contacts, setContacts] = useState([]);
    const [familyDetails, setFamilyDetails] = useState([]);


    useEffect(() => {
        if (memberId) {
            axios
                .post(
                    `https://anoopam.com/aims/api/?action=getmember&memberid=${memberId}&pradesh=&mandal=&format=new`
                )
                .then((res) => {
                    if (res?.data?.status) {
                        const memberData = res.data.data.data;
                        setDetails(memberData);
                        setContacts(memberData?.member?.contact || []);
                        const familyData = memberData?.family;
                        if (familyData) {
                            //   const familyContactsData = Object.values(familyData)?.map(fam => fam?.memberdata?.contact || []).flat();
                            const familyDetail = Object.values(familyData)?.flat();
                            setFamilyDetails(familyDetail)
                        }
                    } else {
                        Swal.fire({
                            title: '',
                            text: res?.data?.message,
                            icon: 'success',
                        });
                        toggle(false);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [memberId, toggle]);


    const handleContactChange = (index, value) => {
        const updatedContacts = [...contacts];
        updatedContacts[index] = { ...updatedContacts[index], contact_value: value };
        setContacts(updatedContacts);
    };

    const handleFamilyContactChange = (familyIndex, contactIndex, value) => {
        const updatedFamilyDetails = [...familyDetails];
        updatedFamilyDetails[familyIndex] = {
            ...updatedFamilyDetails[familyIndex],
            memberdata: {
                ...updatedFamilyDetails[familyIndex].memberdata,
                contact: updatedFamilyDetails[familyIndex].memberdata.contact.map((contact, i) =>
                    i === contactIndex ? { ...contact, contact_value: value } : contact
                ),
            },
        };
        setFamilyDetails(updatedFamilyDetails);
    };

    const handleSubmit = () => {
        const updatedData = {
            member: {
                ...details?.member,
                contact: contacts,
            },
            family: familyDetails.length ? familyDetails : undefined,
        };
        console.log(updatedData);

        axios
            .post('https://anoopam.com/aims/api/?action=member&format=new', updatedData)
            .then((res) => {
                if (res?.data?.status) { 
                    Swal.fire({ 
                        text: `${res?.data?.message}`,
                        icon: 'success',
                    });
                    toggle(false);
                }
            })
            .catch((err) => console.error('Error updating member data:', err));
    };


    console.log(contacts);
    console.log(familyDetails);

    return (
        <div
            className="d-flex align-items-center justify-content-center"
            style={{
                width: '100%',
                height: '100%',
                position: 'fixed',
                top: 0,
                left: 0,
                background: 'rgba(0,0,0,0.6)',
                zIndex: 10,
            }}
        >
            <div className="col-md-8 col-11 bg-white rounded" style={{ maxHeight: '95vh', overflowY: 'auto' }}>
                <div className="col-11 m-auto">
                    <div className="text-start bg-light p-3 rounded-3" style={{borderBottom:'3px solid #001f43'}}>
                        <p className="fw-bold fs-4">
                            {`${details?.member?.title || ''} ${details?.member?.first_name || ''} ${details?.member?.second_name || ''} ${details?.member?.last_name || ''}`}
                        </p>
                        <p className="fs-5 text-secondary">
                            {`${details?.member?.title || ''} ${details?.member?.first_name || ''} ${details?.member?.second_name || ''} ${details?.member?.last_name || ''}`}
                        </p>
                        {contacts?.map((el, index) => (
                            <div key={el.contactid} className="col-lg-5 col-md-7 col-11 mt-2">
                                <label>{el.contact_type}</label>
                                <input
                                    type="text"
                                    value={el.contact_value}
                                    className="form-control"
                                    onChange={(e) => handleContactChange(index, e.target.value)}
                                />
                            </div>
                        ))}
                    </div>


                    {familyDetails.length > 0 && (
                        <div className="text-start mt-2">
                            <p className="fw-bold fs-3">Family </p>
                            <div>
                                {familyDetails?.map((family, familyIndex) => (
                                    <div key={family?.memberdata?.id} class='bg-light mt-3 p-2 rounded-3' style={{borderBottom:'3px solid #001f43'}}>
                                        <p class='fw-bold '>
                                            {`${family?.memberdata?.title || ''} ${family?.memberdata?.first_name || ''} ${family?.memberdata?.second_name || ''} ${family?.memberdata?.last_name || ''}`}
                                        </p>
                                        {family?.memberdata?.contact?.map((contact, contactIndex) => (
                                            <div key={contact.contactid} className="col-lg-5 col-md-7 col-11 mt-2">
                                                <label>{contact.contact_type}</label>
                                                <input
                                                    type="text"
                                                    value={contact.contact_value}
                                                    className="form-control"
                                                    onChange={(e) => handleFamilyContactChange(familyIndex, contactIndex, e.target.value)}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="d-flex gap-3 my-2">
                        <button className="btnBlue btn" onClick={handleSubmit}>Update</button>
                        <button className="btn btn-danger rounded-5" onClick={() => toggle(false)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MemberShortForm;
